import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'delete-modal',
  templateUrl: './delete-dialog.component.html',
  styleUrls: ['./delete-dialog.component.scss']
})
export class DeleteDialogComponent {
  loading: boolean = false;
  @Input("title") title: string;
  @Input("description") description: string;
  @Input("errorText") errorText: string;
  @Input("confirmBtnText") confirmBtnText: string;
  @Input("loadingText") loadingBtnText: string = 'Deleting...';
  @Output() close: EventEmitter<string> = new EventEmitter<string>();
  @Input("isDisabled") isDisable: boolean = false
  showError:boolean =false
  constructor(){}

  closeClick(how: string): void {
    if (how == 'yes') {
      this.loading = true;
      if (this.isDisable) {
        this.showError = true
        this.loading = false
      }
    }
    this.close.emit(how);
  }
}
